class NewsSwiper {
    constructor($container) {
        this.$container = $container;
        this.$nextBtn = $container.find('.js-swipe-news-next');
        this.$prevBtn = $container.find('.js-swipe-news-prev');

        this.$slider = $container.find('.news-slider')[0];
        this.$wrapper = $container.find('.news-swiper-wrapper')[0];

        this.scrollTimer = null;

        if (!this.$slider || !this.$wrapper) {
            return;
        }

        this.init();
    }

    init() {
        this.updateButtons();

        this.$nextBtn.on('click', () => {
            this.swipe('next');
        });

        this.$prevBtn.on('click', () => {
            this.swipe('prev');
        });

        this.$wrapper.addEventListener('scroll', () => {
            window.clearTimeout(this.scrollTimer);

            this.scrollTimer = window.setTimeout(() => {
                this.updateButtons();
            }, 80);
        }, { passive: true });

        window.addEventListener('resize', () => {
            this.updateButtons();
        });
    }

    getSlideWidth() {
        const slide = this.$container.find('.news-swiper-slide')[0];

        if (!slide) return 0;

        const slideStyles = window.getComputedStyle(slide);
        const marginLeft = parseFloat(slideStyles.marginLeft) || 0;
        const marginRight = parseFloat(slideStyles.marginRight) || 0;

        return slide.offsetWidth + marginLeft + marginRight;
    }

    getMaxScrollLeft() {
        return Math.max(0, this.$wrapper.scrollWidth - this.$wrapper.clientWidth);
    }

    swipe(direction = 'next') {
        const slideWidth = this.getSlideWidth();

        if (!slideWidth) return;

        const currentScrollLeft = this.$wrapper.scrollLeft;
        const maxScrollLeft = this.getMaxScrollLeft();

        let targetScrollLeft;

        if (direction === 'next') {
            targetScrollLeft = currentScrollLeft + slideWidth;
        } else if (direction === 'prev') {
            targetScrollLeft = currentScrollLeft - slideWidth;
        } else {
            throw new Error('Incorrect direction');
        }

        targetScrollLeft = Math.max(0, Math.min(targetScrollLeft, maxScrollLeft));

        this.$wrapper.scrollTo({
            top: 0,
            left: targetScrollLeft,
            behavior: 'smooth',
        });

        this.updateButtons();

        window.setTimeout(() => {
            this.updateButtons();
        }, 350);
    }

    updateButtons() {
        const maxScrollLeft = this.getMaxScrollLeft();
        const currentScrollLeft = this.$wrapper.scrollLeft;

        if (maxScrollLeft <= 1) {
            this.$nextBtn.hide();
            this.$prevBtn.removeClass('active');
            return;
        }

        this.$nextBtn.show();

        if (currentScrollLeft > 1) {
            this.enablePrevBtn();
        } else {
            this.disablePrevBtn();
        }

        if (currentScrollLeft >= maxScrollLeft - 1) {
            this.$nextBtn.removeClass('active');
        } else {
            this.$nextBtn.addClass('active');
        }
    }

    enablePrevBtn() {
        this.$prevBtn.addClass('active');
    }

    disablePrevBtn() {
        this.$prevBtn.removeClass('active');
    }
}

export const newsSwiper = new NewsSwiper($('.news'));